import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
   formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
  betweenSeparator: {
    display: "inline",
    verticalAlign: "middle", 
    marginLeft: "8px", 
    fontWeight: "bold", 
    marginTop: "10px"
  }
}));
